import Vue from 'vue'
import dayjs from 'dayjs'
const errorConfig={
    '-103':{ // 禁言
        type:'modal',
        handler:(data)=>{}
    },
    '-115':{ // 违规词
        type:'modal',
        handler:(data)=>{}
    }
}

export function handleBusinessError(code, res) {
  const config = errorConfig[code]
  if (!config) return false
  
  if (config.handler) {
    config.handler(res)
  }
  
  if (config.type === 'modal') {
    // 调用弹窗显示
    Vue.prototype.$showModal({
      message:res.message,
      reason:res.data.reason,
      expire_time: res.data.expire_time,
    })
  }
  
  return true
}
